import { forwardRef } from "react";

/**
 * Renders build-time sanitized HTML from glofox markdown docs.
 * Source HTML is produced by scripts/build-glofox-portal-docs.mjs (sanitize-html).
 */
export const PortalDocHtml = forwardRef<
  HTMLDivElement,
  { html: string; className?: string }
>(function PortalDocHtml({ html, className }, ref) {
  return (
    <div
      ref={ref}
      className={className}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
});
